const STRINGS = {
  APP_TITLE: "My React App",
  WELCOME_MESSAGE: "Welcome to My React App!",
  ERROR_MESSAGE: "An error has occurred. Please try again later.",
  PREVIOUS_SEVEN_DAYS: "Previous 8 Days",
  EXTERNAL_DOCUMENTS: "Only use attached documents",
  BUTTON_TEXT: {
    SUBMIT: "Submit",
    CANCEL: "Cancel",
  },
  HEADER: {
    TITLE: "Researching",
  },
  FOOTER: {
    RESEARCHING_LABEL: "Researching: ",
    RESEARCHING_AUDIT: "Audit",
    RESEARCHING_EBP: "EBP",
    DOCUMENTS_COUNT: "69 documents, 3,177 pages",
    FEEDBACK_PLACEHOLDER: "Ask me anything...",
    INFO_MESSAGE:
      "This tool can make mistakes. Please validate responses against sources.",
  },
  ARCHIVE: {
    PREVIOUS_SEVEN_DAYS: "Previous 7 days",
    PREVIOUS_THIRTY_DAYS: "Previous 30 days",
    TODAY: "Today",
    OLDER: "Older",
    NO_CONVERSATIONS_FOUND: "No conversations found",
  },
  RECENT: {
    PREVIOUS_SEVEN_DAYS: "Previous 7 days",
    PREVIOUS_THIRTY_DAYS: "Previous 30 days",
    TODAY: "Today",
    OLDER: "Older",
    NO_CONVERSATIONS_FOUND: "No conversations found",
  },
  CAROUSEL: {
    EXPERIENCE_REALTIME_INTERACTION: "Experience Real-time Interaction",
    EXPERIENCE_CHATGPT: "Experience CHATGPT 4.0",
    HELP_US_IMPROVE: "Help Us Improve",
    NEW_INDEXES_ARE_HERE: "New Indexes are here",
    STREAMING_FEATURE_DESC:
      "We're excited to announce our new streaming feature! Now, when you ask a question, you'll see a response begin to appear instantly,minimizing wait time and enhancing your interaction with THINK. This means you can receive insights as they're generated - making your workflow",
    FAST_AND_EFFICIENT: "faster and more efficient",
    CHATGPT_DESC: "THINK now utilizes the latest ChatGPT model, providing ",
    REACHER_AND_BETTER: "richer and better-formatted responses.",
    IF_NEEDED: "If needed, you can regenerate for an even better answer.",
    FEEDBACK: "Your feedback matters!",
    FEEDBACK_DESC:
      "Use the Thumbs Up/Thumbs Down icons to mark responses as helpful or needing improvement. Your insights help us, make THINK even better.",
    WRITE_TO_US: "Write to us!",
    INDEXES_DESC: "THINK now supports additional sources for",
    TAX_ADVISORY_CYBER: "Tax,Advisory,Cybersecurity.",
    SELECT_INDEX:
      "Select your index before asking questions to get the most relevant insights!",
    READ_MORE: "Read more ",
  },
  IUNDERSTAND: {
    BEFORE_YOU_THINK: "Before you THINK...",
    RESPONSIBLE_AI_USAGE:
      "AI is a powerful technology but works best when used responsibly and as part of a broader decision-making process.",
    CROSS_CHECK_INFO:
      "Always cross-check AI-provided information with available sources.",
    I_UNDERSTAND_BTN: "I understand",
  },
  EDITCONVERSATION: {
    EDIT_CONVERSATION_TITLE: "Edit Conversation Title",
    CONVERSATION_TITLE_LABEL: "Conversation title",
    PLACEHOLDER: "Enter title",
    CANCEL_BUTTON: "Cancel",
    SAVE_BUTTON: "Save",
  },
  ERRORPOPUP: {
    HEADER: "Something went wrong",
    OOPS: "Oops! Something went wrong. Please reload your page to continue.",
    TECHNICAL: "Technical Details:",
    CONVERSATIONIDNOTFOUND: "Conversation ID:",
    CONVERSATIONNOTFOUND:
      "We can not find the conversation you are looking for. If you need assistance, contact the Help Desk",
    DRAFT_DISABLED: "We are unable to stream the draft chat update right now.",
    CHAT_STREAMING_UNAVAILABLE:
      "We are unable to stream the chat update right now.",
    CONVERSATION_STREAMING_UNAVAILABLE:
      "We are unable to stream the deep search conversation right now.",
    SOURCE_DOC_STREAMING_UNAVAILABLE:
      "We are unable to stream source document answers right now.",
  },
  ATTACHMENTGUIDENCE: {
    ATTACHMENTS_GUIDANCE: `

Please attach specific client reference documents you’d like to add to this conversation. For best results:
 
- Small files tend to provide more accurate responses. You can extract relevant pages from larger documents.  
- **Provide machine-readable files such as searchable PDFs;** support for Word documents, Excel spreadsheets, and images will be available in a future update.  
 No need to upload guidance or standards—they’re already available in our content library.  

`,
  },
  SKILLGUIDENCE: {
    SKILL_GUIDANCE: `<p style="margin: 0 0 0 0;">In the box below Browse</p>
<ul style="margin-top: 0;">
  <li>Click <strong>Browse</strong> to select a file from your computer, or</li>
  <li>Drag and drop the file into this box.</li>
</ul>

<br/>
For best results:

- Small files tend to provide more accurate responses. You can extract relevant pages from larger documents.
- <strong>Provide machine-readable files such as searchable PDFs;</strong> support for Word documents, Excel spreadsheets, and images will be available in a future update.`,
  },
  AAMGUIDENCE: {
    AAM_GUIDANCE: `<p style="margin: 0 0 0 0;">This tool allows you to quickly validate, extract, and transform financial data from structured Excel files into standardized account mappings. Simply upload a supported file format (.xlsx or .xls), and the system will process the data locally, ensuring security and performance.</p>

<br/>
<p style="margin: 0 0 0 0;"><strong>How it works:</strong></p>
<ul style="margin-top: 0;">
  <li><strong>Upload</strong> or drag and drop your <strong>Excel file</strong></li>
  <li>The system validates required columns and extracts data instantly</li>
  <li>Review extracted input data before processing</li>
  <li>Generate mapped output using intelligent automation</li>
  <li>View, filter, and export results in a structured grid</li>
</ul>

<br/>
<p style="margin: 0 0 0 0;"><strong>Important guidelines:</strong></p>
<ul style="margin-top: 0;">
  <li>Ensure your <strong>file contains all required columns</strong> as per the provided template</li>
  <li>Only <strong>structured and machine-readable</strong> Excel files are supported</li>
  <li>Files are processed securely on the client side and are not stored</li>
</ul>`,
  },
};

export default STRINGS;
